webpackJsonp([14],{

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
/** Import frontoffice_app */

__webpack_require__(5);

var _location_handler = _interopRequireDefault(__webpack_require__(7));

var _cart = _interopRequireDefault(__webpack_require__(11));

var _ajax_handler = _interopRequireDefault(__webpack_require__(6));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @class HomeHandler
 */
var HomeHandler =
/*#__PURE__*/
function () {
  /**
   * @constructor
   */
  function HomeHandler() {
    _classCallCheck(this, HomeHandler);

    this._searchButton = $('.frontoffice-tire-search-button');

    this._listenSearchFilters();

    this._listenAddToCart();

    this._listenFilterByCategory();
  }
  /**
   * @private
   */


  _createClass(HomeHandler, [{
    key: "_listenFilterByCategory",
    value: function _listenFilterByCategory() {
      $('#frontoffice-tire-categoryId').on('change', function (e) {
        var value = $(e.target).val();

        if (!value) {
          value = 0;
        }

        var link = 'home/' + value + '/category';

        _ajax_handler.default.get(link).then(function (response) {
          if (response.manufacturers && response.manufacturers.length > 0) {
            var manufacturersStr = '',
                manufacturerFilter = $('#frontoffice-tire-manufacturers');
            $.each(response.manufacturers, function (k, v) {
              manufacturersStr += '<option value="' + v.id + '">' + v.name + '</option>';
            });
            var manVal = manufacturerFilter.val();
            manufacturerFilter.empty();
            manufacturerFilter.html(manufacturersStr);
            manufacturerFilter.val(manVal);
            manufacturerFilter.trigger("chosen:updated");
          }

          if (response.widths) {
            var widthStr = '',
                widthFilter = $('#frontoffice-tire-widths');
            $.each(response.widths, function (k, v) {
              widthStr += '<option value="' + v.id + '">' + v.name + '</option>';
            });
            var widthVal = widthFilter.val();
            widthFilter.empty();
            widthFilter.html(widthStr);
            widthFilter.val(widthVal);
            widthFilter.trigger("chosen:updated");
          }

          if (response.heights) {
            var heightStr = '',
                heightFilter = $('#frontoffice-tire-heights');
            $.each(response.heights, function (k, v) {
              heightStr += '<option value="' + v.id + '">' + v.name + '</option>';
            });
            var heightVal = heightFilter.val();
            heightFilter.empty();
            heightFilter.html(heightStr);
            heightFilter.val(heightVal);
            heightFilter.trigger("chosen:updated");
          }

          if (response.diameters) {
            var diameterStr = '',
                diameterFilter = $('#frontoffice-tire-diameters');
            $.each(response.diameters, function (k, v) {
              diameterStr += '<option value="' + v.id + '">' + v.name + '</option>';
            });
            var diameterVal = diameterFilter.val();
            diameterFilter.empty();
            diameterFilter.html(diameterStr);
            diameterFilter.val(diameterVal);
            diameterFilter.trigger("chosen:updated");
          }
        });
      });
    }
    /**
     * @private
     */

  }, {
    key: "_listenAddToCart",
    value: function _listenAddToCart() {
      $('.add_to_cart').on('click', function (e) {
        e.preventDefault();

        _cart.default.addToCart($(e.target).data('cartitem'));
      });
    }
    /**
     * @private
     */

  }, {
    key: "_listenSearchFilters",
    value: function _listenSearchFilters() {
      var that = this;

      that._searchButton.on('click', function () {
        var selectors = that.constructor._filterSelectors(),
            filterObj = that.constructor._getEmptyFiltersObj();

        $.each(selectors, function (k, v) {
          var val = $(v).val();

          if (v.indexOf('categoryId') >= 0) {
            $.each($(v).find('option'), function (a, b) {
              if (val === $(b).val() && $(b)[0].innerText !== 'Kategorija') {
                filterObj.kategorija.push($(b)[0].innerText.replace('/', '$'));
              }
            });
          }

          if (v.indexOf('seasonId') >= 0) {
            $.each($(v).find('option'), function (c, d) {
              if (val === $(d).val() && $(d)[0].innerText !== 'Sezona') {
                filterObj.sezona.push($(d)[0].innerText.split(' ')[0]);
              }
            });
          }

          if (v.indexOf('manufacturers') >= 0) {
            var manufacturers = [];
            $.each($(v).find('option'), function (e, f) {
              if (val.indexOf($(f).val()) >= 0) {
                manufacturers.push($(f)[0].innerText);
              }
            });
            filterObj.proizvođač = manufacturers;
          }

          if (v.indexOf('widths') >= 0) {
            filterObj.širina = val;
          }

          if (v.indexOf('heights') >= 0) {
            filterObj.visina = val;
          }

          if (v.indexOf('diameters') >= 0) {
            filterObj.prečnik = val;
          }
        });

        that._generateLinkFromFilters(filterObj);
      });
    }
    /**
     * @param filterCollection
     */

  }, {
    key: "_generateLinkFromFilters",
    value: function _generateLinkFromFilters(filterCollection) {
      var data = 'tires/search';
      $.each(filterCollection, function (k, v) {
        if (v.length > 0) {
          data += '/';
          $.each(v, function (a, b) {
            data += k + '-' + b + '+';
          });
          data = data.slice(0, -1);
        }
      });

      _location_handler.default.redirect(data);
    }
    /**
     * @returns {string[]}
     * @private
     */

  }], [{
    key: "_filterSelectors",
    value: function _filterSelectors() {
      return ['#frontoffice-tire-categoryId', '#frontoffice-tire-seasonId', '#frontoffice-tire-manufacturers', '#frontoffice-tire-widths', '#frontoffice-tire-heights', '#frontoffice-tire-diameters'];
    }
    /**
     * @return {{kategorija: Array, sezona: Array, proizvođač: Array, širina: Array, visina: Array, prečnik: Array}}
     * @private
     */

  }, {
    key: "_getEmptyFiltersObj",
    value: function _getEmptyFiltersObj() {
      return {
        kategorija: [],
        sezona: [],
        proizvođač: [],
        širina: [],
        visina: [],
        prečnik: []
      };
    }
  }]);

  return HomeHandler;
}();
/** Start HomeHandler */


$(document).ready(function () {
  new HomeHandler();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

},[249]);


// WEBPACK FOOTER //
// frontoffice_home.js